import React from 'react';

export const DemandDraftPage = () => {
  return (
    <div className="min-h-[80vh] flex items-center justify-center">
      <h1 className="text-4xl sm:text-5xl font-extrabold text-slate-700">Coming Soon</h1>
    </div>
  );
};
